import React from 'react';
import Wrapper from '../ConfirmWrapper';
import { deleteFeed } from 'utils/api';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { logout } from 'redux/modules/auth/action';
import { connect } from 'react-redux';

const RemoveFeedModal = ({ feed, callbackFunc, logout, history }) => {
    const onConfirm = async () => {
        try {
            await deleteFeed(feed.id);
            callbackFunc(feed.id);
            toast.success('Feed succesfully deleted');
        } catch (err) {
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            }
        }
    };
    return (
        <Wrapper confirmButtonTitle="Yes" onConfirm={onConfirm}>
            <div style={{ paddingRight: 25 }}>
                Are you sure you want to delete <b>{feed.name}</b>?
            </div>
        </Wrapper>
    );
};
export default connect(null, { logout })(withRouter(RemoveFeedModal));
